import PrintFormatsService from './print-formats.service'

import { getVariable, setVariable, LOCAL_STORAGE_KEYS } from '@/utils/storage.js'
import { normalize } from './utils'
import type { LocalPrintSettings as TLocalPrintSettings } from '@/types/printing.model.js'
import type { User } from '@/types/models.js'

export const LocalPrintSettings = normalize({
  label: {
    printer: undefined,
    format: PrintFormatsService.forLabels()[0],
  },
  pickingList: {
    printer: undefined,
    format: PrintFormatsService.forPickingLists()[0],
  },
  packingSlip: {
    printer: undefined,
    format: PrintFormatsService.forPackingSlips()[0],
  },
  customs: {
    printer: undefined,
    format: PrintFormatsService.forCustomsDocs()[0],
  },
}) as (_options?: Partial<TLocalPrintSettings>) => TLocalPrintSettings

export const defaults = () => LocalPrintSettings({})

/**
 * Save print options on localstorage
 */
export const save = (options: Partial<TLocalPrintSettings>, user: User): TLocalPrintSettings => {
  const allOptions = LocalPrintSettings(options)
  setVariable(user.id, LOCAL_STORAGE_KEYS.PRINT_OPTIONS, allOptions)
  return allOptions
}

/**
 * Returns print options from localstorage or an empty object if the user hasn't configured local print settings before.
 * NOTE: the type should actually be unknown, but we trust that the value stored in localStorage at least matches the
 * structure of LocalPrintSettings, i.e. can be Partial<LocalPrintSettings>;
 * WARNING: don't use the result of this function without parsing to LocalPrintSettings first;
 */
export const getPartial = (user: User): Partial<TLocalPrintSettings> | Record<string, never> => {
  return getVariable(user.id, LOCAL_STORAGE_KEYS.PRINT_OPTIONS, {})
}

/**
 * Returns print options from localstorage normalized with default values.
 */
export const getAll = (user: User) => LocalPrintSettings(getPartial(user))
